import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { SliderContainer, SliderInput } from './Slider.style';
export function Slider({ value: initialValue, onChange, onChangeEnd = () => {
    return;
}, min = 0, max = 100, step = 1, }) {
    const [minValue, setMinValue] = useState(min);
    const [maxValue, setMaxValue] = useState(max);
    const [value, setValue] = useState(initialValue);
    useEffect(function updateValuesWhenPropChanges() {
        setMinValue(min);
        setMaxValue(max);
        setValue(initialValue);
    }, [initialValue, max, min]);
    return (_jsx(SliderContainer, { children: _jsx(SliderInput, { type: "range", min: minValue, max: maxValue, step: step, value: value, onChange: (e) => onChange(parseInt(e.target.value)), onMouseUp: onChangeEnd }) }));
}
//# sourceMappingURL=Slider.js.map